import React from 'react';
import { Box, Card, Flex, Text } from '@televet/kibble-ui';
import { format } from 'date-fns';
import { Placement } from 'shared/enums';
import ChannelStatusSelect from '../ChannelStatusSelect/ChannelStatusSelect';
import { PetParentChannelFragment } from 'shared/types/graphql';
import partial from 'lodash-es/partial';
import { getAttachmentPreviewLabel } from 'pages/Conversations/utils';

interface ConversationCardProps {
  channel: PetParentChannelFragment;
  isActive?: boolean;
  onCardClick: (channelId: string) => void;
}

// TODO (future): Include this layout in the ConversationCard component in Kibble, or at least
// some variant that excludes the redundant pet parent and pet information.
const PetParentConversationCard = ({ channel, isActive, onCardClick }: ConversationCardProps): JSX.Element => {
  const { channelStatus } = channel;
  return (
    <Card
      isInteractive
      size="sm"
      w="100%"
      className="PetParentProfile__ConversationsCard"
      isActive={isActive}
      key={channel.id}
      onClick={partial(onCardClick, channel.id)}
    >
      <Flex align="center" justify="space-between">
        {channel && channelStatus && (
          <ChannelStatusSelect
            currentStatus={{ id: channelStatus.id, name: channelStatus.name, color: channelStatus.color }}
            channelId={channel.id}
            placement={Placement.BottomEnd}
          />
        )}
        <Text size="xs" variant="default">
          {format(new Date(channel?.updatedAt), "MM/dd/yy '·' h:mm aaaaa'm'")}
        </Text>
      </Flex>
      <Box w="248px" textOverflow="ellipsis" overflow="hidden" overflowWrap="break-word" padding="8px 0">
        <Text size="sm" noOfLines={2} isTruncated>
          {channel?.lastMessage?.body ||
            getAttachmentPreviewLabel(channel?.lastMessage?.attachments?.[0]?.attachmentType) ||
            ''}
        </Text>
      </Box>
    </Card>
  );
};

export default PetParentConversationCard;
